import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Maps Highnote's UPPER_SNAKE_CASE address component constants to the user-facing
 * labels we use in field labels and inline error messages. Returning a single shared
 * mapping keeps the wording consistent across every form that uses address validation.
 */
export function useAddressComponentLabels(): Record<string, string> {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      STREET_ADDRESS: t('streetAddress'),
      EXTENDED_ADDRESS: t('apartmentSuiteEtc'),
      POSTAL_CODE: t('zip'),
      LOCALITY: t('cityOrTown'),
      REGION: t('state'),
      COUNTRY_CODE_ALPHA3: t('country'),
    }),
    [t]
  );
}
